import React from "react";

const HomeLocation = () => {
  return (
    <div id="lokacija" className="location">
      <h2>Kako do nas?</h2>
      <div className="location-grid">
        <div>
          <div className="location-box">
            <i className="fi fi-rs-marker"></i>
            <p>Šumska cesta 2, Gorski kotar</p>
          </div>
          <div className="location-box">
            <i className="fi fi-rs-phone-flip"></i>

            <a href="/"> 095 123 4567</a>
            <h4>(Ivan)</h4>
          </div>

          <div className="location-box">
            <i className="fi fi-rs-phone-flip"></i>
            <a href="/"> 095 000 1234</a>
            <h4>(Klara)</h4>
          </div>
          <div className="location-box">
            <i className="fi fi-rs-at"></i>

            <a href="/"> cabinwoods@gmail.com</a>
          </div>
          <div className="location-box">
            <i className="fi fi-brands-instagram"></i>
            <a href="/">CabinWoods</a>
          </div>
          <div className="location-box">
            <i className="fi fi-brands-facebook"></i>
            <a href="/">Cabin Woods Rent</a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d6347.272344875469!2d15.602577067480606!3d44.80352359286185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1shr!2shr!4v1737796252716!5m2!1shr!2shr"
          width="100%"
          height="250"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Maps Location"
        ></iframe>
      </div>
    </div>
  );
};

export default HomeLocation;
